import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    jewelryEncycData: [],
    keepAlives:[],   //定义keepAlives
  },
  getters: {
    KEEPALIVES(state){     //监听keepAlives
      return state.keepAlives
    }
  },
  mutations: {
    setJewelryEncycData (state, data) {
      state.jewelryEncycData = data;
    },
    SET_KEEP_ALIVE(state,keepAlives) {     //更改store中keepAlives的状态
      return state.keepAlives = keepAlives;
    }
  },
  actions: {
  },
  modules: {
  }
})
